import React, { useEffect, useState } from "react";
import { ExternalLink, Megaphone, Tag } from "lucide-react";
import api from "../lib/api";
import { useLang } from "../context/LangContext";

export default function PromoBlock() {
  const { t } = useLang();
  const [promo, setPromo] = useState(null);

  useEffect(() => { api.get("/public/promo").then((r) => setPromo(r.data)).catch(() => {}); }, []);

  if (!promo) return null;
  const hasCta = promo.cta_enabled && promo.cta_title;
  const affiliates = (promo.affiliates || []).filter((a) => a && a.url && a.title);
  if (!hasCta && affiliates.length === 0) return null;

  return (
    <div className="space-y-4" data-testid="promo-block">
      {hasCta && (
        <div className="rounded-2xl border border-primary/30 bg-primary/10 p-6" data-testid="promo-cta">
          <div className="flex items-center gap-2 text-primary mb-1"><Megaphone className="h-4 w-4" /><span className="text-xs font-semibold uppercase tracking-widest">{t("Destaque", "Featured")}</span></div>
          <h3 className="font-heading text-lg font-bold">{promo.cta_title}</h3>
          {promo.cta_text && <p className="mt-1 text-sm text-muted-foreground">{promo.cta_text}</p>}
          {promo.cta_button_url && (
            <a href={promo.cta_button_url} target="_blank" rel="noreferrer nofollow sponsored" className="mt-4 inline-flex items-center gap-1.5 rounded-lg bg-primary px-4 py-2 text-sm font-semibold text-primary-foreground">
              {promo.cta_button_label || t("Saber mais", "Learn more")} <ExternalLink className="h-4 w-4" />
            </a>
          )}
        </div>
      )}
      {affiliates.length > 0 && (
        <div className="rounded-2xl border border-white/10 bg-card p-5">
          <div className="flex items-center gap-2 text-muted-foreground mb-3"><Tag className="h-4 w-4" /><span className="text-xs font-semibold uppercase tracking-widest">{t("Recomendações", "Recommendations")}</span></div>
          <ul className="space-y-2">
            {affiliates.map((a, i) => (
              <li key={i}>
                <a href={a.url} target="_blank" rel="noreferrer nofollow sponsored" className="flex items-center justify-between gap-2 text-sm text-foreground hover:text-primary transition-colors" data-testid={`affiliate-link-${i}`}>
                  <span>{a.title}</span><ExternalLink className="h-4 w-4 opacity-70" />
                </a>
              </li>
            ))}
          </ul>
          <p className="mt-3 text-[11px] text-muted-foreground">{t("Alguns links podem ser patrocinados.", "Some links may be sponsored.")}</p>
        </div>
      )}
    </div>
  );
}
